import styled from 'styled-components'

const StyledSubscriptionSelectPage = styled.div<{ showUserIcons?: boolean }>`
  .page-header-wrap {
    margin-top: 20px;

    .page-header-main {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .page-title {
        max-width: 300px;
        margin-top: 0;
        margin-bottom: ${({ showUserIcons }) => (showUserIcons ? '20px' : '50px')};
      }

      svg {
        height: 24px;
        color: ${({ theme }) => theme.colors.gray[500]};
      }
    }

    .page-subtitle {
      color: ${({ theme }) => theme.colors.gray[500]};
      font-weight: 400;
    }
  }

  .discount-alert {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    background-color: #dde2e5;
    border-radius: 10px;
    width: fit-content;
    padding: 15px;
    margin-bottom: 35px;

    svg {
      color: ${({ theme }) => theme.colors.gray[600]};
      height: 20px;
      height: 20px;
      flex: none;
      padding-right: 12px;
    }

    p {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.gray[700]};
    }
  }

  .subscription-cards {
    margin-top: 35px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(341px, 1fr));
    gap: 35px 20px;
    align-items: start;
  }

  h1,
  h3 {
    font-family: ${({ theme }) => theme.fonts.lexend};
    color: ${({ theme }) => theme.colors.gray[700]};
  }

  h1 {
    font-size: 32px;
    font-weight: 400;
    margin: 30px 0 50px 0;
    line-height: 45px;
  }

  h3 {
    font-weight: 500;
    font-size: 20px;
  }

  .modal {
    padding: 15px 10px;
    border-radius: 10px;

    .modal-title {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-size: 16px;
      color: ${({ theme }) => theme.colors.green[500]};
      line-height: 24px;
      font-weight: 700;
    }

    .modal-text {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-size: 16px;
      font-weight: 400;
    }

    a {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-size: 16px;
      font-weight: 400;
      text-decoration: underline;
    }

    .modal-footer {
      justify-content: center;
    }
  }
`

export default StyledSubscriptionSelectPage
